import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

import {
  Pagination,
  Empty,
  message,
  Modal,
  ConfigProvider
} from "ant-design-vue";
Vue.use(Pagination);
Vue.use(Empty);
Vue.use(Modal);
Vue.use(ConfigProvider);

import { List } from "vant";
Vue.use(List);

import "./assets/scss/index.scss";
import "../stempcore/src/assets/css/iconfont/iconfont.css";
import { SFieldComponent } from "../stempcore/src/core/sfield";

Vue.use(SFieldComponent);

Vue.prototype.$message = message;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
